import { ApisErrorType } from 'commercial-management--digital--web-components-design--library';

export enum ApisConstants {
    USA_NATIONALITY = 'US'
}

export enum ApisPassengerState {
    COMPLETED = 'APIS_STATE_PASSENGER_COMPLETED',
    PENDING = 'APIS_STATE_PASSENGER_PENDING',
    DOCUMENTATION = 'APIS_STATE_PASSENGER_DOCUMENTATION_AIRPORT',
    CLOSE = 'CLOSE'
}

export enum ApisRequiredFields {
    SURNAME = 'SURNAME',
    NAME = 'NAME',
    GENDER = 'GENDER',
    BIRTH_DATE = 'BIRTH_DATE',
    NATIONALITY = 'NATIONALITY',
    HOME_COUNTRY = 'HOME_COUNTRY',
    DESTINATION_ADDRESS = 'DESTINATION_ADDRESS',
    DESTINATION_CITY = 'DESTINATION_CITY',
    DESTINATION_STATE = 'DESTINATION_STATE',
    DESTINATION_ZIP = 'DESTINATION_ZIP',
    DESTINATION_COUNTRY = 'DESTINATION_COUNTRY',
    CONTACT_DATA = 'CONTACT_DATA',
    EMERGENCY_DATA = 'EMERGENCY_DATA',
    PRIVACY_STATEMENT = 'PRIVACY_STATEMENT'
}

export enum ApisDocuments {
    VISA = 'VISA'
}

export enum ApisStatesCountries {
    US = 'US'
}

export const errorApisTypes: ApisErrorType[] = [
    'TM_VISA_REQUIRED',
    'TM_PSPT_VALIDITY',
    'PSPT_VALIDITY_3_MONTHS',
    'PSPT_VALIDITY_6_MONTHS',
    'API_DOCUMENT_EXPIRY_DATE'
];
export const errorApisTypesESTA: string[] = [
    'TM_ESTA_REQUIRED',
    'TM_RETURN_TICKET_REQUIRED'
];
